import { ApiError, createApi } from '@dugzi/ui';

export { ApiError };

export const APP = 'contacts';

/** The shared client (F-26 C6): `api`, `withAccount` (downloads, the live stream) and this tab's id `TAB`. */
export const { api, withAccount, TAB } = createApi({ app: APP, product: 'Dugzi Contacts' });
